module.exports = __webpack_public_path__ + "static/media/sony-logo-vector.39607aa1.png";